import React, { Fragment, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, Row, Col, Label, FormGroup, Card, CardHeader, Collapse, CardBody } from "reactstrap";

import Rows from "./2_Rows";
import { FieldArray } from "react-final-form-arrays";
import { Field, useFormState } from "react-final-form";

import column_types from "./column_types";
import _ from "lodash";
import { InputField, ReactSelect, required, ToggleField } from "modules/4_final_form/web";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faClone, faPlus } from "@fortawesome/free-solid-svg-icons";
import { v4 as uuidv4 } from "uuid";
import { ConditionalFieldsInputs, getColsAttributes } from "./shared";
import BasicModal from "../BasicModal";

import ConditionsAttributes from "modules/triggers/web/form/ConditionAttributes";
import ActionsAttributes from "modules/triggers/web/form/ActionAttributes";
import toSentence from "modules/5_view_helpers/to_sentence";

const PagesAttributes = (props) => {
  const { fields, column_types, disabled, cloneRevision, revisionIndex, users } = props;
  const [activeTab, setActiveTab] = useState(`page[0]`);


  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const moveLeft = (name, index) => {
    const toIndex = index == 0 ? fields.length - 1 : index - 1;

    const thisValues = fields.value[index];
    const toValues = fields.value[toIndex];
    fields.update(index, { ...thisValues, position: toValues.position });
    fields.update(toIndex, { ...toValues, position: thisValues.position });
    // Change position of the page and also the one on the left of it

    fields.swap(index, toIndex);
    // setTimeout is needed to prevent the tab from being set to the wrong value
    setTimeout(() => {
      setActiveTab(`page[${toIndex}]`);
    }, 1);
  };

  const moveRight = (name, index) => {
    const toIndex = index == fields.length - 1 ? 0 : index + 1;

    const thisValues = fields.value[index];
    const toValues = fields.value[toIndex];
    fields.update(index, { ...thisValues, position: toValues.position });
    fields.update(toIndex, { ...toValues, position: thisValues.position });
    // Change position of the page and also the one on the left of it

    fields.swap(index, toIndex);
    // setTimeout is needed to prevent the tab from being set to the wrong value
    setTimeout(() => {
      setActiveTab(`page[${toIndex}]`);
    }, 1);
  };

  return (
    <div>
      <h3>
        Pages <FontAwesomeIcon icon={faClone} onClick={cloneRevision} title="Clone Revision" style={{ cursor: "pointer" }} />
      </h3>
      <hr />
      <Nav tabs>
        {fields.map((field, i) => {
          const thisField = fields.value[i];
          if (thisField._destroy) return null;

          return (
            <NavItem key={i}>
              <NavLink
                onClick={() => {
                  toggleTab(`page[${i}]`);
                }}
                className={activeTab == `page[${i}]` ? "active" : ""}
              >
                {i > 0 && !disabled && (
                  <Button
                    color="light"
                    size="sm"
                    className="mr-1"
                    onClick={() => {
                      moveLeft(field, i);
                    }}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </Button>
                )}
                <div>{fields.value[i]?.name}</div>
                {i < fields.length - 1 && fields.length > 1 && !disabled && (
                  <Button
                    color="light"
                    size="sm"
                    className="ml-1"
                    onClick={() => {
                      moveRight(field, i);
                    }}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                  </Button>
                )}
              </NavLink>
            </NavItem>
          );
        })}
        {!disabled && (
          <NavItem>
            <NavLink
              onClick={() => {
                if (!disabled) {
                  fields.push({
                    name: `Page ${fields.length + 1}`,
                    guid: uuidv4(),
                    position: fields.length + 1,
                    show_on_create: true,
                    show_on_update: true,
                  });
                  toggleTab(`page[${fields.length}]`);
                }
              }}
            >
              Add Page
              <FontAwesomeIcon className="ml-2" icon={faPlus} />
            </NavLink>
          </NavItem>
        )}
      </Nav>
      <TabContent activeTab={activeTab}>
        {fields.map((field, i) => {
          const thisField = fields.value[i];
          const rows_attributes = _.filter(thisField.rows_attributes, (row) => !row._destroy);

          if (thisField._destroy) return null;

          return (
            <TabPane key={i} tabId={`page[${i}]`}>
              <PageTabs
                field={field}
                pageIndex={i}
                column_types={column_types}
                thisField={thisField}
                disabled={disabled}
                rows_attributes={rows_attributes}
                deletePage={() => {
                  if (thisField.id) {
                    fields.update(i, { id: thisField.id, _destroy: "1" });
                  } else {
                    fields.remove(i);
                  }
                  setActiveTab(`page[${fields.length - 2}]`);
                }}
                isFirstPage={i == 0}
                revisionIndex={revisionIndex}
                users={users}
              />
            </TabPane>
          );
        })}
      </TabContent>
      {_.isEmpty(fields.value) && disabled && <p>No pages</p>}
    </div>
  );
};

PagesAttributes.defaultProps = {
  column_types: column_types,
};

export default PagesAttributes;

export const PageTabs = (props) => {
  const { field, column_types, disabled, rows_attributes, deletePage, thisField, isFirstPage, revisionIndex, pageIndex, users } = props;

  const [activeTab, setActiveTab] = useState("details");
  return (
    <Fragment>
      <Nav tabs>
        <NavItem>
          <NavLink
            onClick={() => {
              setActiveTab("details");
            }}
            style={{ cursor: "pointer" }}
            className={activeTab == `details` ? "active" : ""}
          >
            Details
          </NavLink>
        </NavItem>
        {!thisField.group_label && (
          <Fragment>
            <NavItem>
              <NavLink
                onClick={() => {
                  setActiveTab("design");
                }}
                style={{ cursor: "pointer" }}
                className={activeTab == `design` ? "active" : ""}
              >
                Design
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                onClick={() => {
                  setActiveTab("triggers");
                }}
                style={{ cursor: "pointer" }}
                className={activeTab == `triggers` ? "active" : ""}
              >
                Page Triggers
              </NavLink>
            </NavItem>
          </Fragment>
        )}
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="design">
          <FieldArray
            name={`${field}.data.rows_attributes`}
            component={Rows}
            column_types={column_types}
            disabled={disabled}
            revisionIndex={revisionIndex}
          />
        </TabPane>
        <TabPane tabId="details">
          {_.isEmpty(rows_attributes) && !disabled && (
            <Row>
              <Col>
                <Button onClick={deletePage} color="danger" size="sm">
                  Delete Page
                </Button>
              </Col>
            </Row>
          )}

          <PageDetails field={field} thisField={thisField} isFirstPage={isFirstPage} revisionIndex={revisionIndex} users={users} />
        </TabPane>
        <TabPane tabId="triggers">
          <TriggersTab thisField={thisField} field={field} revisionIndex={revisionIndex} pageIndex={pageIndex} />
        </TabPane>
      </TabContent>
    </Fragment>
  );
};

const PageDetails = (props) => {
  const { field, thisField, isFirstPage, revisionIndex, users } = props;

  return (
    <Fragment>
      <FormGroup row>
        <Label md={2}>Page Name</Label>
        <Col md={4}>
          <Field name={`${field}.name`} component={InputField} validate={required} />
        </Col>
      </FormGroup>
      {!thisField.info_page && (
        <FormGroup row>
          <Label md={2}>Group Label</Label>
          <Col md={2}>
            <Field name={`${field}.group_label`} component={ToggleField} />
          </Col>
        </FormGroup>
      )}
      {!thisField.group_label && (
        <FormGroup row>
          <Label md={2}>Info Page</Label>
          <Col md={2}>
            <Field name={`${field}.info_page`} component={ToggleField} />
          </Col>
          {thisField.info_page && (
            <Fragment>
              <Label md={2}>Info Link</Label>
              <Col md={4}>
                <Field name={`${field}.info_link`} component={InputField} />
              </Col>
            </Fragment>
          )}
        </FormGroup>
      )}

      {!thisField.group_label && (
        <Fragment>
          <FormGroup row>
            <Label md={2}>Show on create</Label>
            <Col md={2}>
              <Field name={`${field}.show_on_create`} component={ToggleField} />
            </Col>
            <Label md={2}>Show on update</Label>
            <Col md={2}>
              <Field name={`${field}.show_on_update`} component={ToggleField} />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label md={2}>Hide next steps until complete</Label>
            <Col md={2}>
              <Field name={`${field}.hide_next_steps`} component={ToggleField} />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label md={2}>Default Person Responsible</Label>
            <Col md={2}>
              <Field
                component={ReactSelect}
                options={_.map(users, (e) => {
                  return { label: e.name, value: e.id };
                })}
                name={`${field}.default_user_id`}
                isClearable
                parse={(value) => value}
              />
            </Col>
          </FormGroup>

          {!isFirstPage && (
            <Fragment>
              <FormGroup row>
                <Label md={2}>Conditonally Visible</Label>
                <Col md={2}>
                  <Field name={`${field}.conditionally_visible`} component={ToggleField} />
                </Col>
              </FormGroup>
              <hr />
              {thisField.conditionally_visible && (
                <ConditionalFieldsInputs
                  revisionIndex={revisionIndex}
                  uid={thisField.uid}
                  position={thisField.position}
                  conditional_field_name={`${field}.conditional_field`}
                  conditional_selected_name={`${field}.conditional_selected_value`}
                  conditional_boolean_name={`${field}.conditional_boolean_value`}
                  conditional_value_name={`${field}.conditional_value`}
                />
              )}
            </Fragment>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

const TriggersTab = (props) => {
  const { users, thisField, field } = props;
  const formState = useFormState();
  const { values } = formState;
  const parent_type = values?.parent_type;

  const cols_attributes = getColsAttributes(values, thisField?.position);
  let inputs = _.filter(cols_attributes, (col) => col?.column_type != "text" && col?.column_type != "attachments");

  return (
    <div>
      <FieldArray name={`${field}.triggers_attributes`} component={TriggersAttributes} inputs={inputs} users={users} parent_type={parent_type} />
    </div>
  );
};

const TriggersAttributes = (props) => {
  const { fields, inputs, users, parent_type } = props;

  const removeTrigger = (index) => {
    const thisValues = fields.value[index];

    if (thisValues.id) {
      fields.update(index, {
        ...thisValues,
        _destroy: true,
      });
    } else {
      fields.remove(index);
    }
  };

  return (
    <div>
      {fields.map((field, index) => {
        const thisValues = fields.value[index];
        if (thisValues._destroy) return null;

        return (
          <TriggerFields
            field={field}
            key={index}
            index={index}
            fields={fields}
            values={thisValues}
            parent_type={parent_type}
            removeTrigger={() => {
              removeTrigger(index);
            }}
            users={users}
            inputs={inputs}
          />
        );
      })}

      <hr />
      <Button
        onClick={() => {
          fields.forEach((field, index) => {
            fields.update(index, {
              ...fields.value[index],
              open: false,
            });
          });

          fields.push({
            open: true,
            on_page_complete: true,
          });
        }}
      >
        Add Trigger
      </Button>
    </div>
  );
};

const TriggerFields = (props) => {
  const { field, index, values, inputs, fields, removeTrigger, users, parent_type } = props;
  const { open = false, name, on_page_complete } = values;

  const toggle = () => {
    fields.update(index, {
      ...fields.value[index],
      open: !open,
    });
  };

  let labels = [];
  if (on_page_complete) {
    labels.push("on page complete");
  }

  let label = name;
  if (labels.length > 0) {
    label = `${name} (${toSentence(labels)})`;
  }

  return (
    <Card className="mt-2">
      <CardHeader
        onClick={toggle}
        style={{
          cursor: "pointer",
        }}
      >
        <Col md={10}>{label || "New Trigger"}</Col>
        <Col md={2}>
          <BasicModal
            buttonLabel="Remove Trigger"
            buttonColor="danger"
            successButtonLabel="Yes"
            onSuccessClick={() => {
              removeTrigger(index);
            }}
            title={`Remove Trigger`}
          >
            Are you sure you want to remove this Trigger?
          </BasicModal>
        </Col>
      </CardHeader>
      <Collapse isOpen={open}>
        <CardBody>
          <FormGroup row>
            <Label md={2}>Name</Label>
            <Col md={4}>
              <Field component={InputField} name={`${field}.name`} validate={required} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={2}>On page complete</Label>
            <Col md={2}>
              <Field component={ToggleField} name={`${field}.on_page_complete`} />
            </Col>
            {/* <Label md={2}>On update</Label>
            <Col md={2}>
              <Field component={ToggleField} name={`${field}.on_update`} />
            </Col>
            <Label md={2}>On destroy</Label>
            <Col md={2}>
              <Field component={ToggleField} name={`${field}.on_destroy`} />
            </Col> */}
          </FormGroup>
          <hr />
          <FieldArray name={`${field}.conditions_attributes`} labels={labels} inputs={inputs} component={ConditionsAttributes} />
          <hr />
          <FieldArray
            name={`${field}.actions_attributes`}
            labels={labels}
            users={users}
            inputs={inputs}
            parent_type={parent_type}
            component={ActionsAttributes}
          />
        </CardBody>
      </Collapse>
    </Card>
  );
};
